import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c4daf9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel-header flex justify-content-between align-items-center" }
const _hoisted_2 = { class: "panel-header-content flex align-items-center flex-grow-1" }
const _hoisted_3 = { class: "flex-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "panel-trigger-icon pi ml-s2 pi-chevron-down" }, null, -1))
const _hoisted_5 = {
  class: "toggleable-content",
  role: "region"
}
const _hoisted_6 = { class: "panel-content" }

import { ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PanelCollapse',
  props: {
    header: null,
    panelClass: null,
    collapsed: { type: Boolean },
    hideHeader: { type: Boolean },
    marked: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["onCollapse"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'onCollapse', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  header?: string;
  panelClass?: string;
  collapsed?: boolean;
  hideHeader?: boolean;
  marked?: boolean;
  disabled?: boolean;
}



const isCollapsePanel = ref(props.collapsed);
const toggle = () => {
  isCollapsePanel.value = !isCollapsePanel.value;
  emits('onCollapse', isCollapsePanel.value);
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["panel-collapse", __props.panelClass])
  }, [
    (!__props.hideHeader)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", {
                class: _normalizeClass({ 'text-marked': __props.marked })
              }, [
                _renderSlot(_ctx.$slots, "header", {}, () => [
                  _createTextVNode(_toDisplayString(__props.header), 1)
                ])
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_Button, {
                class: _normalizeClass(["panel-trigger md:ml-s1 w-full md:w-auto", isCollapsePanel.value ? '' : 'active']),
                onClick: toggle,
                "aria-expanded": !isCollapsePanel.value,
                disabled: __props.disabled
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["class", "aria-expanded", "disabled"])
            ])
          ]),
          (!isCollapsePanel.value && __props.header)
            ? (_openBlock(), _createBlock(_component_Divider, {
                key: 0,
                class: "my-s3 panel-collapse-divider"
              }))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "toggleable-content" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ], 512), [
          [_vShow, !isCollapsePanel.value]
        ])
      ]),
      _: 3
    })
  ], 2))
}
}

})